import vNumberInput from "./number";
const directive = (Vue:any) => {
  Vue.directive("number-input", vNumberInput);
};
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(directive)
});
